import React, { useContext } from 'react'
import styled from 'styled-components'
import htmlParser from 'html-react-parser'
import Divider from '@jarvis.oddle/core/components/Divider'
import { P } from '@jarvis.oddle/core/components/Typo'
import Form from '@jarvis.oddle/core/components/Form'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'
import { CardHeader, Section } from './Elements'
import { padding, paddingSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

export const FormTextArea = styled(Form.TextArea)`
  padding-top: ${padding[paddingSizes.small]} !important;
  margin-top: 1.5em;
  min-height: 55px;
  height: 90px;
  max-height: 140px;
`

interface AdditionalInfoProps {
  additionalInstructions: string
}

const AdditionalInfo = ({
  additionalInstructions
}: AdditionalInfoProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  return (
    <React.Fragment>
      <Section>
        <CardHeader>{t('Additional Information')}</CardHeader>
        {additionalInstructions && (
          <InlineNotification lightTheme state={notificationStates.informative}>
            {htmlParser(additionalInstructions)}
          </InlineNotification>
        )}
        <P bold>{t('Customer remarks')}</P>
        <FormTextArea
          name='additionalRemarks'
          label={t('Customer Remarks or Pickup/Delivery Instructions')}
        />
      </Section>
      <Divider />
    </React.Fragment>
  )
}

export default AdditionalInfo
